import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProSidebarProvider } from 'react-pro-sidebar';
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import { transitions, positions, Provider as AlertProvider } from 'react-alert'
//react-alert-template-basic
import AlertTemplate from 'react-alert-template-basic'

const options = {
    // you can also just use 'bottom center'
    // position: positions.BOTTOM_CENTER,
    position: positions.MIDDLE,
    timeout: 3000,
    // offset: '30px',
    // zIndex:1051,
    // zindex:999999999999999999999999,

    // zIndex : 100,
    // you can also just use 'scale'
    transition: transitions.FADE,
    // width:'80%'
}

const style = {
    width:'1000px'
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AlertProvider template={AlertTemplate} {...options}>
        <BrowserRouter>
            <ProSidebarProvider>
                <App />
            </ProSidebarProvider>
        </BrowserRouter>
    </AlertProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
